import React, { useContext } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { QuestionsContext } from "../../../../../../../provider/MyContexts";
import SortableOptions from "./SortableOptions";
import { Question } from "../../../../../../../type";
import SortableMartix from "./SortableMartix";
import SortableInputs from "./SortableInputs";
import { AutoAwesome } from "@mui/icons-material";

type Props = {};

export default function OptionArea(props: Props) {
  const {} = props;

  const {
    questions,
    selectedQuestion,
    addInitOption,
    generateQuestion,
    isLoading,
    updateQuestions,
  } = useContext(QuestionsContext);

  const handleOptionsChange = (newOptions: object[]) => {
    const newValue = questions.map((question: Question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          options: newOptions.map((i, index) => {
            return {
              ...i,
              itemId: `${index + 1}`, // ユニークID
            };
          }),
        };
      }
      return question;
    });
    updateQuestions(newValue);
  };

  const handleOptionsDelete = (index: number) => {
    // setQuestions((prev: Question[]) => {
    let optionItems = [];

    // selectedQuestion.options.forEach((itemGroup, index1) => {
    //   itemGroup.forEach((item, index2) => {
    //     optionItems.push({
    //       ...item,
    //       itemId: `${index2 + 1}`,
    //       id: `${item.text}-${index1}-${index2}`, // ユニークID
    //       header: itemGroup.length != 0 ? selectedQuestion.itemHeaders[index1] : "",
    //       headerIndex: index1,
    //     });
    //   });
    // });

    const newValue = questions.map((question: Question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          options: [...selectedQuestion.options.filter((_, i) => i !== index)],
        };
      }
      return question;
    });
    updateQuestions(newValue);

    // });
  };

  const handleMatrixChange = (newMatrix: object[]) => {
    const newValue = questions.map((question: Question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          loop: newMatrix.map((i, index) => {
            return {
              ...i,
              itemId: `-${index + 1}`, // ユニークID
            };
          }),
        };
      }
      return question;
    });
    updateQuestions(newValue);
  };
  const handleMatrixDelete = (index: number) => {
    const newValue = questions.map((question: Question) => {
      if (question.questionId === selectedQuestion.questionId) {
        return {
          ...question,
          loop: question.loop
            .filter((_, i) => i !== index)
            .map((i, index) => {
              return {
                ...i,
                itemId: `-${+index.toString().replace("-", "") + 1}`, // ユニークID
              };
            }),
        };
      }
      return question;
    });
    updateQuestions(newValue);
  };

  function switchContents() {
    const questionType = selectedQuestion.questionType;

    if (["SA", "MA", "性別"].includes(questionType)) {
      return <SortableOptions onChange={handleOptionsChange} handleDelete={handleOptionsDelete} />;
    } else if (questionType.includes("マトリクス")) {
      return (
        <Stack spacing={1}>
          <SortableMartix onChange={handleMatrixChange} handleDelete={handleMatrixDelete} />
          <SortableOptions
            onChange={handleOptionsChange}
            handleDelete={handleOptionsDelete}
            isMatrix={true}
          />
        </Stack>
      );
    } else if (
      questionType.includes("FA") ||
      questionType.includes("NA") ||
      questionType.includes("TX") ||
      questionType.includes("年齢")
    ) {
      return <SortableInputs onChange={handleOptionsChange} handleDelete={handleOptionsDelete} />;
    } else {
      return <></>;
    }
  }

  return (
    <Stack width={"100%"} marginBottom={2} flex={1}>
      {!selectedQuestion.questionType.includes("マトリクス") && (
        <Stack direction={"row"} width={"100%"} justifyContent={"space-between"}>
          <Typography flex={1} variant="heading_XS" marginBottom={1}>
            選択肢・入力欄
          </Typography>
        </Stack>
      )}

      {(selectedQuestion.questionType.includes("マトリクス") &&
        (selectedQuestion.loop.length || selectedQuestion.options.length)) ||
      selectedQuestion.options.length ? (
        <Stack>{switchContents()}</Stack>
      ) : (
        <Stack flex={1} minHeight={180} alignItems={"center"} justifyContent={"center"} spacing={2}>
          <Typography
            variant="body_L"
            sx={{
              color: "#666",
              fontWeight: 600,
            }}
          >
            {"マトリクス選択肢、入力欄のデータがありません。"}
          </Typography>
          <Stack direction={"row"} spacing={2}>
            <Button
              variant="outlined"
              onClick={() => {
                addInitOption(selectedQuestion.questionType);
              }}
              disabled={!selectedQuestion.questionType}
            >
              <Typography variant="button">自分でつくる</Typography>
            </Button>
            <Button
              variant="contained"
              disabled={
                !selectedQuestion.questionTitle ||
                !selectedQuestion.questionType ||
                !selectedQuestion.questionText
              }
              loading={isLoading}
              loadingPosition="start"
              onClick={() => {
                generateQuestion("ALL");
              }}
            >
              <Typography variant="button">AIサポート</Typography>
            </Button>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}

type AICommandsProps = {
  area: "options" | "matrix" | "inputs";
  handleAdd: () => void;
  handleAddHeader?: () => void;
};

export function AiCommands(props: AICommandsProps) {
  const { area, handleAdd, handleAddHeader } = props;

  const { generateQuestion, selectedQuestion, isLoading } = useContext(QuestionsContext);

  const label = area == "options" ? "選択肢" : area == "matrix" ? "行項目" : "入力欄";
  return (
    <Stack
      width={"100%"}
      direction={"row"}
      spacing={1}
      alignItems={"center"}
      justifyContent={"flex-start"}
      marginBottom={0.5}
    >
      <Button
        variant="outlined"
        size="small"
        disabled={
          !selectedQuestion.questionTitle ||
          !selectedQuestion.questionType ||
          !selectedQuestion.questionText
        }
        loading={isLoading}
        onClick={() => {
          generateQuestion(area == "options" ? "OPTIONS" : "LOOP");
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <AutoAwesome fontSize="small" />
          <Typography variant="button">{label + "を生成する"}</Typography>
        </Stack>
      </Button>
      {area == "options" ? (
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            if (handleAddHeader) {
              // if (!selectedQuestion.optionHeaders.length){
              handleAddHeader();
              // } else {
              //   const lastHeader = selectedQuestion.optionHeaders[selectedQuestion.optionHeaders.length - 1]
              //   // const optionLength = selectedQuestion.optionHeaders[selectedQuestion.optionHeaders.length - 1]
              //   // if (lastHeader.to = )

              // }
            }
          }}
        >
          <Typography variant="button">見出しを追加</Typography>
        </Button>
      ) : (
        <></>
      )}
      <Button variant="outlined" size="small" onClick={handleAdd}>
        <Typography variant="button">{label + "を追加"}</Typography>
      </Button>
    </Stack>
  );
}
